export enum TIMELINE_ROUTINE_KEY {
  MORNING_ROUTINE = 'morning_routine',
  WORK = 'work',
  EVENING_ROUTINE = 'evening_routine',
  FREE_TIME = 'free_time',
  SLEEP = 'sleep'
}

export const TIMELINE_ROUTINE_KEYS = [
  TIMELINE_ROUTINE_KEY.MORNING_ROUTINE,
  TIMELINE_ROUTINE_KEY.WORK,
  TIMELINE_ROUTINE_KEY.EVENING_ROUTINE,
  TIMELINE_ROUTINE_KEY.FREE_TIME,
  TIMELINE_ROUTINE_KEY.SLEEP
] as const;

export enum SETTINGS_DELETE_TARGET {
  HABIT = 'habit',
  CUSTOM_ROUTINE = 'custom_routine'
}

